import React from 'react'
import {style} from 'glamor'
import * as colors from '../colors'

export default ({children, ...props}) => (
  <h3
    {...props}
    {...style({
      letterSpacing: '0.125rem',
      fontSize: '0.875rem',
      color: colors.darkGray,
      textTransform: 'uppercase',
      fontWeight: 'normal',
      margin: 0,
      marginBottom: '0.5rem',
    })}
  >
    {children}
  </h3>
)



/** WEBPACK FOOTER **
 ** ./src/components/SectionTitle.js
 **/